<a
  *wlGenericLink="link()"
  class="top-task__button d-flex flex-column justify-content-center p-2"
  [ngClass]="'top-task--theme-' + theme()"
  wlTrackLink
  [trackLinkInfo]="{
    rendering: { componentName: 'ContentTopTasksButtonComponent' },
    field: linkText() ?? '',
    eventType: 'link-click',
    type: 'navigation',
  }"
>
  <ng-container *wlShowInLive>
    <crnt-icon
      [icon]="iconValue() ?? 'question'"
      class="top-task__button-icon mb-1"
    />
    <span class="top-task__button-text">{{ linkText() }}</span>
  </ng-container>
</a>
